<template>
    <div>
        <a-row :gutter="24" type="flex">
            <a-col :span="24" class="mb-24">
                <a-card :bordered="false" class="header-solid h-full" :bodyStyle="{ padding: 0 }">
                    <template #title>
                        <a-row type="flex" align="middle">
                            <a-col :span="24" :md="12">
                                <h5 class="font-semibold m-0">
                                    مهمانان سمینار
                                </h5>
                            </a-col>
                            <a-col :span="24" :md="12"
                                style="
                  display: flex;
                  align-items: center;
                  justify-content: flex-end;
                ">
                                <a-button class="btn-outline-purple" icon="search" @click="isHidden = !isHidden">
                                    جستجو
                                </a-button>
                                &nbsp;
                                  <a-button class="btn-outline" icon="plus" @click="isHidden2 = !isHidden2">
                                    افزودن دستی
                                </a-button>
                                &nbsp;
                            <ExcelModal :seminar="info" @getData="getData" v-show="$root.hasPermission('/seminars/excel/')" />

                                &nbsp;
                            </a-col>
                        </a-row>
                    </template>
                    <b-card style="margin:20px; !important ; border:none;" v-if="isHidden">
                            <div class="row">
                                <div class="col-md-6 my-1">
                                    <label class="sr-only" for="inline-form-input-name">
                                        شماره همراه</label>
                                    <b-form-input v-model="search.phone" id="inline-form-input-name" class="">
                                    </b-form-input>
                                </div>
                                <div class="col-md-6 my-1">
                                     <UserSearch @ids="getIds" />

                                </div>
                                <div class="col-md-2">
                                    <a-button class="btn-outline-green w-100" icon="search" @click="getData">
                                        جستجو
                                    </a-button>
                                </div>
                            </div>
                    </b-card>
                     <b-card style="margin:20px; !important ; border:none;" v-if="isHidden2">
                    <form @submit.prevent="addGuest($event)">

                            <div class="row">
                                <div class="col-md-3 my-1">
                                    <label class="sr-only" for="inline-form-input-name">
                                        شماره همراه</label>
                                    <input type="text" name="phone" v-model="info2.phone" class="form-control" >

                                </div>

                                <div class="col-md-3 my-1">
                                    <label>
                                         نام</label>
                                  <input type="text" name="name" v-model="info2.name" class="form-control" >

                                </div>

                                <div class="col-md-3 my-1">
                                    <label >
                                         نام خانوادگی</label>
                                     <input type="text" name="family" v-model="info2.family" class="form-control" >

                                </div>
                                 <div class="col-md-3 my-1">
                                    <label >
                                          کد ملی</label>
                                     <input type="text" name="national_code" v-model="info2.national_code" class="form-control" >

                                </div>

                                <div class="col-md-3 my-1">
<label class="sr-only" for="inline-form-input-name">  کاربر تماس گیرنده</label>
                                <select v-model="info2.caller_id" class="form-control" name="caller_id">
                                    <option value="">انتخاب</option>
                                    <option v-for="host in info.hosts" :value="host.user.id">{{host.user ?  $root.full_name(host . user . firstname , host . user . lastname) : '' }}</option>
                                </select>

                                </div>
                                  <div class="col-md-3 my-1">
                                <label class="sr-only" for="inline-form-input-name">  سانس</label>
                                <select v-model="info2.sans_id" class="form-control" name="sans_id">
                                    <option value="">انتخاب</option>
                                    <option v-for="sans in info.sans" :value="sans.id"> {{ sans.start_hour+'-'+sans.end_hour }}</option>
                                </select>
                            </div>
                              <div class="col-md-3">
</div>
                                <div class="col-md-3 mt-md-3">
                                    

                                     <button :disabled="loading" type="submit" class="btn btn-fill btn-outline-success w-100">
                                        ذخیره
                                    </button>

                                </div>
                            </div>



                        </form>
                    </b-card>


                    <a-row style="justify-content: center; display: flex" v-if="$store.state.loading">
                        <template>
                            <div>
                                <a-spin />
                            </div>
                        </template>
                    </a-row>
                    <div v-else>
                        <section class="w-100 p-4 text-center">
                          <div class="table-responsive">
                            <table class="table table-hover">
                                <thead>
                                    <tr>
                                        <th scope="col">شناسه</th>
                                        <th scope="col">شماره موبایل</th>
                                        <th scope="col"> نام و نام خانوادگی</th>
                                        <th scope="col"> تماس گیرنده </th>
                                        <th scope="col"> تعداد همراه</th>
                                        <th scope="col"> توضیحات </th>
                                        <th scope="col"> تماس گرفته شده </th>
                                        <th scope="col"> دعوت پذیرفته شده </th>
                                        <th scope="col">   عملیات </th>
                                        <th scope="col">   حذف مهمان </th>


                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="row in data">
                                        <th scope="row">#{{ row.id }}</th>
                                        <td>{{ row.phone }}</td>
                                        <td>
                                            <b-badge variant="light" class="text-dark">{{$root.full_name(row.name,row.family)  }} </b-badge>
                                        </td>
                                        <td>
                                            <b-badge variant="light" class="text-dark">{{row.caller ?  $root.full_name(row . caller . firstname , row . caller . lastname) : '' }}</b-badge>
                                        </td>
                                        <td>
                                            {{ row.count }}
                                        </td>
                                        <td> {{ row.description }}</td>
                                        <td>
                                         <a-switch v-model="row.called == 1 ? row.called=true:row.called=false"  @change="changeCalled(row.id)"
                                          :disabled="!$root.hasPermission('/seminars/callcenterCall/')" />
                                        </td>
                                        <td>
                                         <a-switch v-model="row.accepted == 1 ? row.accepted=true:row.accepted=false" @change="changeAccepted(row.id)"
                                          :disabled="!$root.hasPermission('/seminars/callcenterInvite/')" />
                                        </td>
                                        <td>
                                            <div class="d-flex">
                                                <Callcenter v-if="row.accepted == 1 && row.called == 1 " :data="row" @getData="getData" />
                                                 &nbsp;
                                            <a-button v-if="row.accepted != 1 || row.called != 1" class="btn-outline-danger" shape="square" icon="delete"
                                              v-show="$root.hasPermission('/seminars/callcenter-delete/')"
                                                @click="deleteRow(`seminars/call/delete/${row.id}`)"></a-button>                               
   
                                            </div> 


                                        </td>
                                        <td>
                                            <a-button
                                                    class="btn-outline-danger"
                                                    shape="square"
                                                    icon="delete"
                                                    v-show="$root.hasPermission('/seminars/guests/delete/')"
                                                    v-if="row.is_user != 1"
                                                    @click="deleteRow(`seminars/guests/delete/${row.id}`)"
                                            ></a-button>
                                        </td>

                                    </tr>
                                </tbody>

                            </table>
                            </div>
                        </section>
                        <a-row class="pagination">
                            <a-pagination :total="total" :item-render="$root.itemRender"
                                @change="getData(currentPage)" v-model="currentPage" />
                        </a-row> 
                    </div>
                </a-card>
            </a-col>
        </a-row>
    </div>
</template>

<script>
    import ExcelModal from '../../components/Seminars/ModalUploadSeminar.vue';
    import Callcenter from '../../components/Seminars/ModalCallCenter.vue';
    import UserSearch from "../../components/Blocks/UserSelectMultiple.vue"


    export default {
        components: {
            ExcelModal,
            Callcenter,
            UserSearch
        },
        data() {
            return {
                data: [],
                currentPage: 1,
                total: 0,
                isHidden: false,
                isHidden2:false,
                loading:false,
                search: {
                    phone: "",
                    caller_id: []
                },
                info2:{}
            };
        },
        methods: {
             getCallerIds(value) {
                this.info2.caller_id=value
            },
             addGuest(event) {
                let _this = this;
                let data = new FormData(event.target);
                let caller_id=this.info2.caller_id
                let sans_id=this.info2.sans_id
                this.loading = true;
                axios
                    .post("/seminars/guests/add", data)
                    .then(function(response) {
                        _this.loading = false;
                        _this.$toast.success(" مهمان با موفقیت افزوده شد");
                        _this.getData();
                        _this.info2={
                            'phone':"",
                            'name':"",
                            'caller_id':caller_id,
                            'family':"",
                            'sans_id':sans_id,
                            'national_code':""
                        };
                    })
                    .catch(function(err) {
                        _this.loading = false;
                        _this.$root.handleAxiosError(err);
                    });
            },
              getIds(value) {
                this.search.caller_id=value
            },
        async getData() {
            let _this = this;
            let url = `/seminars/guests?page=${this.currentPage}&&phone=${this.search.phone}&&caller_id=${this.search.caller_id}&&seminar_id=${this.$route.params.id}`;
            axios
                .get(url)
                .then(function(response) {
                    _this.$store.state.loading = false;
                    _this.data = response.data.data.data;
                    _this.total = response.data.data.total;
                    _this.currentPage = response.data.data.current_page;
                })
                .catch(function(err) {
                    _this.$root.handleAxiosError(err);
                });
        },
        
        async changeCalled(id){
              let _this = this;
                this.$store.state.loading = true;
                let url =
                    `/seminars/guests/called/${id}`;
                await axios
                    .get(url)
                    .then(function(response) {
                        _this.getData();
                        _this.$toast.success("کاربر مورد نظر با موفقیت ویرایش شد.");

                    })
                    .catch(function(err) {
                        _this.$root.handleAxiosError(err);
                    });
         },
        async changeAccepted(id){
              let _this = this;
                this.$store.state.loading = true;
                let url =
                    `/seminars/guests/accepted/${id}`;
                await axios
                    .get(url)
                    .then(function(response) {
                        _this.getData();
                        _this.$toast.success("کاربر مورد نظر با موفقیت ویرایش شد.");

                    })
                    .catch(function(err) {
                        _this.$root.handleAxiosError(err);
                    });
            },
            handleChange(){
            },
             showModal() {
                this.visible = true;
            },
            handleOk(e) {
                this.loading = true;
                setTimeout(() => {
                    this.visible = false;
                    this.loading = false;
                }, 3000);
            },
            handleCancel(e) {
                this.visible = false;
            },
           deleteRow(url) {
                this.$swal({
                    title: "آیا از حذف اطلاعات اطمینان دارید؟",
                    showDenyButton: true,
                    showCancelButton: false,
                    confirmButtonText: "بله",
                    denyButtonText: "لغو",
                }).then((result) => {
                    if (result.isConfirmed) {
                        let _this = this;
                        axios
                            .get(url)
                            .then(function(response) {
                                _this.$toast.success("با موفقیت حذف شد.");
                                _this.getData();
                            })
                            .catch(function(err) {
                                _this.$toast.error("امکان حذف کاربر وجود ندارد.");
                                _this.$root.handleAxiosError(err);
                            });
                    }
                });
            },
        },
        mounted() {
            this.getData();
            let _this = this;
                axios
                .get("/seminars/single/" + this.$route.params.id)
                .then(function(response) {
                    _this.info = response.data;
                })
                .catch(function(err) {
                    _this.$root.handleAxiosError(err);
                });
        },
    };
</script>

<style scope>
    .pagination {
        display: flex;
        justify-content: center;
        margin: 15px;
    }
</style>
